
import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { Bet, BetOutcome } from '../../types.ts';

interface OutcomePieChartProps {
  bets: Bet[];
}

const OutcomePieChart: React.FC<OutcomePieChartProps> = ({ bets }) => {
  const finalizedBets = bets.filter(b => b.outcome !== BetOutcome.PENDING);
  const total = finalizedBets.length;

  if (total === 0) return null;

  const counts = {
    [BetOutcome.GREEN]: finalizedBets.filter(b => b.outcome === BetOutcome.GREEN).length,
    [BetOutcome.RED]: finalizedBets.filter(b => b.outcome === BetOutcome.RED).length,
    [BetOutcome.REFUND]: finalizedBets.filter(b => b.outcome === BetOutcome.REFUND).length,
  };

  const data = [
    { name: 'Ganhou', value: counts[BetOutcome.GREEN], color: '#00ff66', label: 'Ganhou' },
    { name: 'Perdida', value: counts[BetOutcome.RED], color: '#f6465d', label: 'Perdida' },
    { name: 'Reembolso', value: counts[BetOutcome.REFUND], color: '#4788ff', label: 'Reembolso(Push)' },
  ].filter(d => d.value > 0);

  return (
    <div className="flex flex-col h-full">
      <h4 className="text-white font-black text-center text-lg mb-4 uppercase tracking-tighter">
        RESULTADOS (SEM PENDENTES)
      </h4>

      <div className="flex-1 min-h-[180px]">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              innerRadius={55}
              outerRadius={80}
              paddingAngle={2}
              dataKey="value"
              stroke="none"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip
              contentStyle={{
                backgroundColor: '#1e2329',
                border: '1px solid #474d57',
                borderRadius: '12px',
                color: '#eaecef'
              }}
              itemStyle={{ color: '#eaecef', fontWeight: 'bold' }}
              labelStyle={{ display: 'none' }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>

      <div className="grid grid-cols-2 gap-3 mt-4">
        {data.map((item, idx) => {
          const percentage = total > 0 ? ((item.value / total) * 100).toFixed(2) : '0.00';
          return (
            <div key={idx} className="bg-[#0b0e11]/50 border border-[#474d57]/30 p-3 rounded-2xl flex flex-col items-center justify-center text-center">
              <div className="flex items-center gap-2 mb-1">
                <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: item.color }}></div>
                <span className={`text-[10px] font-bold uppercase truncate max-w-[100px] ${item.name === 'Ganhou' ? 'text-[#00ff66]' : 'text-[#b1b5c0]'}`}>{item.label}</span>
              </div>
              <div className="text-sm font-black text-[#eaecef]">
                {item.value} <span className="text-[#b1b5c0] text-[10px] font-medium">({percentage}%)</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OutcomePieChart;
